import { commentItems } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            用户热评
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            看看吃瓜在线的用户们都怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {commentItems.map((comment) => (
            <div
              key={comment.id}
              className="p-5 md:p-6 rounded-xl bg-background-50 border border-background-200"
            >
              {/* Avatar + Name */}
              <div className="flex items-center gap-3 mb-3">
                <img
                  src={comment.avatar}
                  alt={comment.name}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div>
                  <p className="text-sm font-semibold text-foreground-900">
                    {comment.name}
                  </p>
                  <p className="text-xs text-foreground-500">{comment.date}</p>
                </div>
              </div>

              {/* Content */}
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                {comment.text}
              </p>

              {/* Likes */}
              <div className="flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-heart-line text-primary-500"></i>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}